import Layout from "@/components/Layout";
import PageHero from "@/components/PageHero";
import ServiceAreas from "@/components/ServiceAreas";
import NextPageCta from "@/components/NextPageCta";
import { BOOK_URL } from "@/lib/booking";

export default function AreasPage() {
  return (
    <Layout>
      <PageHero
        eyebrow="Service Areas"
        title="Warwickshire"
        italic="& surrounding areas."
        blurb="Based in Leamington Spa and covering everywhere within a sensible drive. If your postcode isn't on the list — ask. Travel for larger jobs is always considered."
      />
      <ServiceAreas />
      <NextPageCta href={BOOK_URL} label="Book your slot →" sub="Live availability on my diary." />
    </Layout>
  );
}
